// extracted by mini-css-extract-plugin
module.exports = {"galleryPanel":"styles_galleryPanel__iUGsN","fadeInOut":"styles_fadeInOut__0n7X5","loader":"styles_loader___A2na"};